import type { Account } from '@shared/products-types';
import { createSingleton } from '@luna/utils';
import type { UseEntities } from '@luna/api';

export interface AccountStrategy {
    useGapiAccounts: () => ReturnType<
        UseEntities<
            Account,
            {
                accountsFilter?: (accounts: Account[]) => Account[];
                onSuccess?: (accounts: Account[]) => void;
            }
        >
    >;
    useWebAPIAccounts?: () => ReturnType<
        UseEntities<
            Account,
            {
                onSuccess?: (accounts: Account[]) => void;
            }
        >
    >;
    onAccountsFetchRequest?: () => void;
    onAccountsFetchSuccess?: (fetchedGAPIAccounts: Account[], fetchedWebAPIAccounts: any) => void;
    onAccountsFetchFailure?: () => void;
}

const { set, get } = createSingleton<AccountStrategy>();

export const getAccountStrategyOrThrowError = (): AccountStrategy => {
    const strategy = get();
    if (!strategy) {
        throw new Error('Strategy is not initialized');
    }
    return strategy;
};

export const setAccountStrategy = (strategy: AccountStrategy): void => {
    set(strategy);
};
